var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasInstructions
    ? _c("div", { staticClass: "cc-guide" }, [
        _c("span", { staticClass: "az-ds-card-title" }, [
          _vm._v("Passo a passo")
        ]),
        _c(
          "ol",
          { staticClass: "cc-steps" },
          _vm._l(_vm.steps, function(step, index) {
            return _c("li", { key: index, staticClass: "cc-steps__item" }, [
              _c("span", { staticClass: "cc-steps__number" }, [
                _vm._v(_vm._s(index + 1))
              ]),
              _c("div", { staticClass: "cc-steps__content" }, [
                _c(
                  "span",
                  { staticClass: "az-ds-card-title cc-steps__title" },
                  [_vm._v(_vm._s(step.title))]
                ),
                _c(
                  "span",
                  { staticClass: "az-ds-aux cc-steps__detail" },
                  _vm._l(step.segments, function(seg, sIndex) {
                    return _c(
                      "span",
                      { key: sIndex, class: { "cc-steps__hl": seg.highlight } },
                      [_vm._v(_vm._s(seg.text))]
                    )
                  }),
                  0
                )
              ])
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }